// extracted by mini-css-extract-plugin
module.exports = {"Popup":"Popup_Popup__8g4Qq"};